// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"728113fd","493":"d871faeb","648":"7d83c50e","785":"9bbb5b4e","797":"5a451faf","811":"29198918","875":"66188655","908":"efdfac28","934":"0f751ed6","976":"33fc1843"}[chunkId] + ".chunk.js";
};